import styled from "styled-components";
import { tokens } from "../../public/tokens";

export const StyledDestructiveBulkButton = styled.button({
    height: "35px",
    padding: `0 ${tokens.globals["spacing-4"]}`,
    border: `1px solid ${tokens.colors.ui.destructive}`,
    borderRadius: tokens.globals["border-radius"],
    background: tokens.colors.ui.destructive,
    color: tokens.colors.neutral.white,
    boxShadow: tokens.effects.effects.shadow.default,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: tokens.globals["spacing-1-5"],
    fontFamily: tokens.typography.fontFamilies["albert-sans"],
    fontSize: tokens.typography.fontSize["lg-14px"],
    fontWeight: tokens.typography.fontWeights.semibold,
    cursor: "pointer",
    whiteSpace: "nowrap",
});

export const StyledExportGroup = styled.div({
    display: "flex",
    alignItems: "center",
    gap: tokens.globals["spacing-3"],
});

export const StyledExportButton = styled.button({
    width: "18px",
    height: "24px",
    padding: 0,
    border: 0,
    background: "transparent",
    color: tokens.colors.neutral.grey["800"],
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",

    i: {
        fontSize: tokens.typography.fontSize["lg-14px"],
        lineHeight: tokens.typography.fontSize["lg-14px"],
    },

    "&:hover:not(:disabled)": {
        color: tokens.colors.brand.blue["500"],
    },

    "&:focus-visible": {
        outline: `1px solid ${tokens.colors.brand.blue["500"]}`,
        outlineOffset: "2px",
    },

    "&:disabled": {
        opacity: 0.5,
        cursor: "not-allowed",
    },
});

export const StyledResetButton = styled.button({
    height: "35px",
    padding: `0 ${tokens.globals["spacing-2-5"]}`,

    border: `1px solid ${tokens.colors.neutral.black}`,
    borderRadius: tokens.globals["border-radius"],

    background: tokens.colors.neutral.black,
    color: tokens.colors.neutral.white,

    boxShadow: tokens.effects.effects.shadow.default,

    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: tokens.globals["spacing-1-5"],

    fontFamily: tokens.typography.fontFamilies["albert-sans"],
    fontSize: tokens.typography.fontSize["lg-14px"],
    fontWeight: tokens.typography.fontWeights.semibold,
    lineHeight: "20px",

    cursor: "pointer",

    i: {
        fontSize: tokens.typography.fontSize["lg-14px"],
        lineHeight: tokens.typography.fontSize["lg-14px"],
    },

    "&:hover:not(:disabled)": {
        background: tokens.colors.neutral.grey["800"],
        borderColor: tokens.colors.neutral.grey["800"],
    },

    "&:focus-visible": {
        outline: `1px solid ${tokens.colors.brand.blue["500"]}`,
        outlineOffset: "2px",
    },

    "&:disabled": {
        opacity: 0.5,
        cursor: "not-allowed",
    },
});
